import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userService from "./userService";
import { flashMessage as flash } from "./../../../utils/flash/index";

const initialState = {
  all_users: [],
  unpaginated_users: [],
  isLoading: false,
  isSuccess: false,
  createSuccess: false,
  isError: false,
  isActivating: false,
  isUnlocking: false,
  isChanged: false,
  searchLoading: false,
  isTransferred: false,
  message: "",
  user_info: {},
  user_customers: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUsers: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isChanged = false;
      state.searchLoading = false;
      state.createSuccess = false;
      state.message = "";
      state.user_customers = [];
    },
    resetTransfer: (state) => {
      state.isTransferred = false;
      state.user_customers = [];
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetching Users
      .addCase(fetchAllUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.data) {
          state.all_users = action.payload.data;
          state.unpaginated_users = action.payload.user;
        }
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // fetch user customers
      .addCase(getUserCustomers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserCustomers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.customers) {
          state.user_customers = action.payload.customers;
          // state.unpaginated_users = action.payload.user;
        }
      })
      .addCase(getUserCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // SearchUsers
      .addCase(searchUsers.pending, (state) => {
        state.searchLoading = true;
      })
      .addCase(searchUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.searchLoading = false;
        if (action.payload.search_all_users) {
          state.all_users = action.payload.search_all_users;
        }
      })
      .addCase(searchUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Fetching single User
      .addCase(fetchSingleUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSingleUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        if (action.payload.data) {
          state.user_info = action.payload.data;
        }
      })
      .addCase(fetchSingleUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Transfer Customers
      .addCase(transferCustomer.pending, (state) => {
        state.pending = true;
        flash("info", "Transferring customers...");
      })
      .addCase(transferCustomer.fulfilled, (state, action) => {
        state.pending = false;
        if (action.payload.message) {
          state.isTransferred = true
          flash("success", action.payload.message);
        } 
      })
      .addCase(transferCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.pending = false;
        state.message = action.payload;
        flash("error", action.payload);      
      })
      // Create User
      .addCase(createUser.pending, (state) => {
        state.pending = true;
        flash("info", "User is creating");
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.pending = false;
        if (action.payload.user) {
          state.isError = false;
          state.isSuccess = true;
          state.createSuccess = true;
          flash("success", "User created successfully");
        } else if (action.payload.errors.email) {
          flash("error", action.payload.errors.email[0]);
        } else if (action.payload.errors.staff_id) {
          flash("error", action.payload.errors.staff_id[0]);
        }
      })
      .addCase(createUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Update User
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
        flash("info", "Updating");
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data) {
          state.isError = false;
          state.isSuccess = true;
          flash("success", "User updated successfully");
          // state.all_users.push(action.payload.user)
        } else if (action.payload.error) {
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          // let error = action.payload.errors.email;
          state.isLoading = false;
          state.isError = true;
          state.message = "an error occured";
          flash("error", action.payload.errors[0]);
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // activateUser user
      .addCase(activateUser.pending, (state) => {
        state.isActivating = true;
      })
      .addCase(activateUser.fulfilled, (state, action) => {
        state.isActivating = false;
      })
      .addCase(activateUser.rejected, (state, action) => {
        state.isActivating = false;
        flash("error", action.payload);
      })
      // unlock user
      .addCase(unlockUser.pending, (state) => {
        state.isUnlocking = true;
      })
      .addCase(unlockUser.fulfilled, (state, action) => {
        state.isUnlocking = false;
        flash("success", action.payload.message);
      })
      .addCase(unlockUser.rejected, (state, action) => {
        state.isUnlocking = false;
        flash("error", action.payload);
      })

      // deactivateUser user
      .addCase(deactivateUser.pending, (state) => {
        state.isActivating = true;
      })
      .addCase(deactivateUser.fulfilled, (state, action) => {
        state.isActivating = false;
        // state.staff_information = action.payload.data;
      })
      .addCase(deactivateUser.rejected, (state, action) => {
        state.isActivating = false;
        // state.isError = true;
        // state.message = action.payload;
        flash("error", action.payload);
      })
      // change Password
      .addCase(changePassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.errors?.password) {
          flash("error", action.payload.errors.password[0]);
        } else if (action.payload.errors) {
          flash("error", "Old password doesn't match your current password");
        } else if (action.payload.message) {
          state.isChanged = true;
          flash("success", "Password has been changed successfully");
        }
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.isLoading = false;
        // state.isError = true;
        // state.message = action.payload;
        flash("error", action.payload);
      });
  },
});

// Create user
export const createUser = createAsyncThunk(
  "/users/create",
  async (userData, thunkAPI) => {
    try {
      return await userService.createUser(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Create user
export const updateUser = createAsyncThunk(
  "/users/update",
  async (userData, thunkAPI) => {
    try {
      return await userService.updateUser(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Fetch users
export const fetchAllUsers = createAsyncThunk(
  "/users/getAll",
  async (pageNumber, thunkAPI) => {
    try {
      return await userService.getAllUsers(pageNumber);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch single user
export const fetchSingleUser = createAsyncThunk(
  "/users/Single",
  async (id, thunkAPI) => {
    try {
      return await userService.getSingleUser(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// Unlock a user
export const unlockUser = createAsyncThunk(
  "/user/unlock",
  async (id, thunkAPI) => {
    try {
      return await userService.unlockUser(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// deactivate a user
export const deactivateUser = createAsyncThunk(
  "/user/deactivate-user",
  async (staff_id, thunkAPI) => {
    try {
      return await userService.deactivateUser(staff_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// deactivate a user
export const activateUser = createAsyncThunk(
  "/user/activate-user",
  async (staff_id, thunkAPI) => {
    try {
      return await userService.activateUser(staff_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// change user password
export const changePassword = createAsyncThunk(
  "/user/changePassword",
  async (id, thunkAPI) => {
    try {
      return await userService.changePassword(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// search users
export const searchUsers = createAsyncThunk(
  "/user/searchUsers",
  async (data, thunkAPI) => {
    try {
      return await userService.searchUsers(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getUserCustomers = createAsyncThunk(
  "/user/getUserCustomers",
  async (data, thunkAPI) => {
    try {
      return await userService.getUserCustomers(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const transferCustomer = createAsyncThunk(
  "/user/transferCustomer",
  async (data, thunkAPI) => {
    try {
      return await userService.transferCustomer(data);
    } catch (error) {
      const message = 
        error.response?.data?.error || 
        error.response?.data?.message || 
        "Something went wrong";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetUsers, logState, resetTransfer } = userSlice.actions;
export default userSlice.reducer;
